import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PackageX } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useAlertaFaixa } from './alertas/AlertasContexto';

// Faixa "FALTOU ITEM" — divergencia de recebimento registrada e ainda nao finalizada (16/10/2026).
//
// Pedido do Ruan: quando alguem registrar que um item da nota nao chegou, isso vira pendencia no
// cabecalho ate o admin clicar em "Finalizar Divergencia" na propria nota. So admin ve: e' a unica
// porta de apagar a pendencia, e alarme que o leitor nao consegue resolver vira ruido.
//
// O numero cai na hora em que alguem registra ou finaliza (evento 'divergencias-recebimento:mudou'
// disparado pela tela de Notas de Entrada); o polling cobre o que acontece em outra maquina.
interface NotaAberta { id: number; numero: string; itens: number }

const POLLING_MS = 5 * 60 * 1000;

export function AlertaDivergenciaRecebimentoBanner() {
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [notas, setNotas] = useState<NotaAberta[] | null>(null);

  const podeVer = usuario?.perfil === 'admin';

  useEffect(() => {
    if (!podeVer) return;
    let cancelado = false;
    async function tick() {
      try {
        const r = await api.get<{ notas: NotaAberta[] }>('/api/notas-entrada/divergencias/resumo');
        if (!cancelado) setNotas(r.notas);
      } catch { /* silencioso: a faixa some, o resto da tela nao cai por causa dela */ }
    }
    void tick();
    const id = setInterval(tick, POLLING_MS);
    window.addEventListener('divergencias-recebimento:mudou', tick);
    return () => {
      cancelado = true;
      clearInterval(id);
      window.removeEventListener('divergencias-recebimento:mudou', tick);
    };
  }, [podeVer]);

  const ativo = !!(podeVer && notas && notas.length > 0);
  const recolhido = useAlertaFaixa(
    'divergencia-recebimento',
    ativo ? { rotulo: 'Faltou item', bg: '#f97316', borda: '#c2410c', qtd: notas!.length } : null,
  );

  if (!ativo || recolhido || !notas) return null;

  const n = notas.length;
  const unica = n === 1 ? notas[0] : undefined;
  const destino = unica ? `/notas-entrada?nota=${unica.id}` : '/notas-entrada?divergencia=aberta';
  return (
    <div
      style={{
        background: '#f97316',
        borderLeft: '4px solid #c2410c',
        color: '#000',
        padding: '8px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 13,
        cursor: 'pointer',
      }}
      onClick={() => navigate(destino)}
    >
      <PackageX size={16} />
      <span style={{ fontWeight: 600 }}>Faltou item:</span>
      <span>
        {unica
          ? `a nota ${unica.numero} tem item que nao chegou, aguardando finalizar`
          : `${n} notas tem item que nao chegou, aguardando finalizar`}
      </span>
      <span style={{ marginLeft: 'auto', textDecoration: 'underline' }}>Ver {n === 1 ? 'nota' : 'notas'}</span>
    </div>
  );
}
